/*
 * Generates a single search filter for the application. Mostly lifted from the old STV app
 * with the addition of an endpoint property to be used to retrieve data from the api
 */
import React from "react";
import { ValueType } from "react-select/src/types";
import useFilterOptions, { OptionType } from "../hooks/useFilterOptions";
import Select from "./Select";
import { TICKET_API_URL } from "../environmentVariables";
import { Query } from "../helpers/interfaceHelper";

interface ItemFilterProps {
  setFilter: (p: string, v: string[]) => void;
  property: string;
  name: string;
  disabled: boolean;
  query: Query;
  endpoint: string;
}

function isValidQueryParam(prop: string, params: Query): prop is keyof Query {
  return prop in params;
}

const ItemsFilter: React.FC<ItemFilterProps> = ({
  setFilter,
  property,
  name,
  disabled,
  query,
  endpoint,
}) => {
  const options = useFilterOptions(`${TICKET_API_URL}`, endpoint);

  const handleChange = (value: ValueType<OptionType>) => {
    if (value instanceof Array) {
      setFilter(
        property,
        value.map((v) => v.value)
      );
    } else if (value) {
      setFilter(property, [(value as OptionType).label]);
    } else {
      setFilter(property, []);
    }
  };

  //the query can return various types, including numbers, strings, arrays and objects.
  //as such, it is probably better to use any here rather than a union of all of the available types
  let selectedFilters: any;
  if (isValidQueryParam(property, query)) {
    selectedFilters = query[property];
  } else {
    selectedFilters = [];
  }

  if (typeof selectedFilters === "string") {
    selectedFilters = [selectedFilters];
  } else if (typeof selectedFilters === "object" && selectedFilters["$nin"]) {
    const not = selectedFilters["$nin"];
    selectedFilters = options
      .map((o) => o.value)
      .filter((o) => !not.includes(o));
  } else if (typeof selectedFilters === "object" && selectedFilters["$in"]) {
    const filterin = selectedFilters["$in"];
    selectedFilters = options
      .map((o) => o.value)
      .filter((o) => filterin.includes(o));
  }

  return (
    <Select
      options={options}
      selectedValues={selectedFilters}
      onChange={handleChange}
      name={name}
      disabled={disabled}
    />
  );
};

export default ItemsFilter;
